import getEmbedUrl from './getEmbedUrl';
import DateUtils from './DateUtils';
import extractPlaybackUrl from './extractPlaybackUrl';

const getVideoObjectSchema = (mediaItem, config, lang) => {

    return {
        '@context': 'https://schema.org',
        '@type': 'VideoObject',
        name: mediaItem?.title,
        description: mediaItem?.description,
        thumbnailUrl: (mediaItem?.image?.cuts ?? []).find(cut => cut.width >= 1536)?.src ?? config?.shareConfig?.defaultShareImg ?? '',
        uploadDate: mediaItem?.date,
        duration: DateUtils.durationToISOString(mediaItem?.duration),
        contentUrl: extractPlaybackUrl(mediaItem, config),
        embedUrl: getEmbedUrl(mediaItem, config, lang),
    };

};

export default getVideoObjectSchema;
